import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {InputLabel, FormControl, Select as MaterialSelect  ,Box ,TextField,
  FormControlLabel, LinearProgress, Checkbox, Typography,
RadioGroup, Radio, FormLabel} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import {toast} from "react-toastify";
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../funciones/ClienteAxios";
import Modal from '../Generales/ModalTam';
import Rating from '@material-ui/lab/Rating';
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      selectEmpty: {
        marginTop: theme.spacing(2),
      },
      Textnumero: {
        width: 5+"px",
      },
      formControlFull: {
        //margin: theme.spacing(1),
        //minWidth: 120,
        width:5+"rem"
      },
      margin: {
        margin: theme.spacing(1),
      },
    },
  }));

const NvoEditMarca = ({modalAbierto,setModalAbierto,titulo,regis,funcionActuliza}) => {
  let history = useHistory();
  const classes = useStyles();
  const source = axios.CancelToken.source(); 
  const idusu = localStorage.getItem('UsuId');
  const [espera,setEspera]=useState(false);
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');
  const [aviso, setAviso] = useState(false); 
  const [btnDesact, setBtnDesact] = useState(false); 
  const [registro, setRegistro]= useState({Orden:0, Color:"#0c7a2d", Descr:"", });  
  const {Orden,  Color, Descr, }=registro    
  
  const [listEstado, setListEstado] = useState([])  
  const [listMuni, setListMuni] = useState([])    
  
  React.useEffect(()=>{     
    //console.log(regis);
    if (regis.length !== 0) {
      setRegistro({...registro,   Color:regis.Col, Orden:regis.Id,
      Descr:regis.Descr, })        
    }
 

    return ()=> {
      source.cancel();
    }     
      // eslint-disable-next-line react-hooks/exhaustive-deps	
  },[]);

  const registrarNActividad=()=>{               
  
    //let NomUsu= localStorage.getItem('UsuarioNom');  
    const data = qs.stringify({
      Llave:Orden,
      Usuario:idusu,                        
      Status:1,      
      Nombre:Descr,
      Color:Color,      
      ip:"172.2.0.0",      
      idDispositivo:'8978yuhjnfrsdsd'
    });
    const url = "/maquinaria/marca/new-edit";
  
    function respuesta(aux) {
      if (aux.respuesta==1) 
      { //console.log(aux);
        let mensaje= regis.length!==0 ?
        `Se edito correctamente el registro "${Descr} " `        
        :`Se Registro correctamente la nueva Marca `
        setTipoAdvertencia("success")      
        setMensaje(mensaje);
        setAviso(true)     
        toast.success(mensaje, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });       
        funcionActuliza()
        setModalAbierto(false)            
      }   
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);     
  }

  const onChange = e =>
  { let expNopermitida = new RegExp('[#_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9]');
    if ((expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value) )||e.target.value===' '||e.target.value==='') 
    {
    
      setRegistro({ ...registro, [e.target.name] : e.target.value  })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };
  
  const onChangeColor = e =>
  {
    setRegistro({ ...registro,Color: e.target.value })
  };

  const validaDatos=(valor, mensaje)=>{
    let respuesta=false    
    if (valor!= null && valor!= '' && valor!= '0' && valor!== 0 ) 
    { respuesta=true     
    }
    else
    { setTipoAdvertencia("warning")    
      setMensaje(mensaje);
      setAviso(true)     
    }
    return respuesta
  }

  const guardarDatos = () => 
  {
    if (validaDatos(Color,"Llenar campo de Color")  ) 
    {
      if ( ((Descr.length>=5 && validaDatos(Descr, "Llenar campo de Nombre (mayor a 5 caracteres)") ))
        || (Descr.length<5 && validaDatos(0, "Llenar campo de Nombre (mayor a 5 caracteres)"))
      ) 
      {//console.log(registro);
      
        registrarNActividad()                                                                           
      }   
               
    }                            
  };

  const onChangeRef = e =>
  { let expNopermitida = new RegExp('[$!?]');
    //let expMenos = new RegExp('-');
    //let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9#_:%-({})/*=|]');
    if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) ) 
        || e.target.value===' ' || e.target.value==='') 
    {    
      setRegistro({ ...registro, [e.target.name] : e.target.value  })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };


  
  return ( 
  <Modal
    titulo={titulo} modalAbierto={modalAbierto}
    setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
    mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
    aviso={aviso} setAviso={setAviso} espera={espera} 
    setEspera={setEspera}  tamanio={"md"} btnDesact={btnDesact}
  >
  <form className={classes.root} noValidate autoComplete="off" fullWidth style={{width:31+'rem'}} >                               
    <Box display={"flex"} flexDirection={"row"} mb={2}>
      
     <Box style={{width:25+'rem'}} mt={2}>      
      <FormControl component="fieldset" style={{width:25+'rem'}}>    
        <TextField id="outlinedDescr" variant='outlined'           
          label="Nombre"  size="small"
          value={Descr} onChange={onChangeRef}  
          name="Descr" fullWidth
        /> 
      </FormControl>
      </Box>     
    <Box style={{width:5+'rem'}} ml={1}>      
      <FormControl component="fieldset" style={{width:5+'rem'}}>   
        <Typography>Color</Typography> 
        <input  type="color" name="Color" value={Color} onChange={e => onChangeColor(e)} />
      </FormControl>
      </Box>     
    </Box>

      
     
      </form>
  </Modal>
  );
}
 
export default NvoEditMarca;